import _ from 'lodash';
import moment from 'moment';
import templateStr from 'text!./covered-employees.html';
import 'portalConfig';
import DateUtil from 'gw-portals-util-js/DateUtil';
import PropertyCodeViewDirective from 'edge/platform/widgets/typeahead/matchContentDirectives/PropertyCode/PropertyCode';
import PropertyCodeUtil from 'edge/quoteandbind/common/util/PropertyCodeUtil';
import ViewModelUtil from 'edge/gw-portals-bop-components-angular/node_modules/gw-portals-viewmodel-js/ViewModelUtil.js';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        transclude: true,
        scope: {
            hideForm: '&',
            saveCoveredEmployees: '&',
            data: '=',
            stateErrors: '=',
            disablePrevious: '=?',
            disableNext: '=?',
            perCapitaClasses: '=?'
        },
        controller: ['$scope', 'PolicyService', 'UserService', 'RenewalService', 'qnb.PropertyCodeLookupService', '$window', '$q', 'ModalService', 'ViewModelService', '$state', '$filter', function ($scope, PolicyService, UserService, RenewalService, PropertyCodeLookupService, $window, $q, ModalService, ViewModelService, $state, $filter) {

            $scope.selectedEntry = -1;
            // DEF0932-GHC-Portal-In CCEW.js in the code $scope.employee = ViewModelService.create
            $scope.employeeView = ViewModelService.create({}, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');
            var lookupCodesPromise = RenewalService.getAllClassCodes();
            $scope.classcodeLookup = {
                getMatches: function getMatches(userinput) {
                    return lookupCodesPromise.then(function (propertyCodes) {
                        return _(propertyCodes).filter(function (code) {
                            return PropertyCodeUtil.toString(code).toLowerCase().includes((userinput || '').toLowerCase());
                        }).take(10).valueOf();
                    }).catch(function () {
                        return ModalService.showError('gw-portals-bop-components-angular.locationsAndBuildings.building.buildingCtrl.Error retrieving property class code', 'gw-portals-bop-components-angular.locationsAndBuildings.building.buildingCtrl.Please check for errors and try again');
                    });
                },
                toString: function toString(code) {
                    if (ViewModelUtil.isViewModelNode(code)) {
                        return code.value;
                    }

                    return PropertyCodeUtil.toString(code);
                },
                directive: PropertyCodeViewDirective
            };

            $scope.selectedEntry = -1;

            //adding new class
            $scope.addClass = function () {
                $scope.isAddingNew = true;
                $scope.selectedEntry = -1;
                $scope.stateErrors.missingClass = false;
                $scope.newEmployee = {
                    basisAmount: null,
                    classCode: '',
                    description: '',
                    location: '',
                    noOfEmployees: null,
                    perCapita: null,
                    suffix: ''

                };
                $scope.employeeView = ViewModelService.create($scope.newEmployee, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');
                //setting up location options
                $scope.employeeLocationView = {
                    aspects: {
                        inputCtrlType: "typelist",
                        required: false,
                        availableValues: $scope.data.value.baseData.mSFLocations,
                        visible: true,
                        get valid() {
                            return $scope.employeeView.location.value;
                        }
                    },
                    value: ''

                };
            };
            $scope.onEdit = function (index) {
                $scope.isAddingNew = false;
                $scope.isEditing = true;
                $scope.selectedEntry = index;
                $scope.resetErrors();
                var currentEditingData = angular.copy($scope.data.value.baseData.mSFCoveredEmployees_EXT[index]);
                //setting up location
                $scope.employeeView = ViewModelService.create(currentEditingData, 'pc', 'edge.capabilities.policy.dto.WCCoveredEmployeeDTO_Ext');

                $scope.employeeLocationView = {
                    aspects: {
                        inputCtrlType: "typelist",
                        required: false,
                        availableValues: $scope.data.value.baseData.mSFLocations,
                        visible: true,
                        get validationMessages() {
                            return ['This is a required field'];
                        },
                        get valid() {
                            return $scope.employeeView.location.value;
                        }
                    },
                    value: $scope.employeeView.location.value

                };
            };

            //check suffix on class code change
            //service to check risk id availability
            $scope.$watch('employeeView.value.classCode', function (newVal) {
                var classCode = document.getElementById('gwClassCode');
                if (classCode != null && classCode.querySelector("textarea").value.length > 10) {
                    //set cursor in starting position
                    console.log('in first loop');

                    var input = classCode.querySelector("textarea");

                    //for IE
                    if (input.createTextRange) {
                        var part = input.createTextRange();
                        part.moveEnd("character", 0);
                        part.moveStart("character", 0);
                        part.select();
                    } else if (input.setSelectionRange) {
                        input.setSelectionRange(0, 0);
                    }
                }
                if (newVal != null && newVal != undefined) {
                    if (newVal.mSFClassIndicator == '00') {
                        RenewalService.getClassCodeBycode(newVal.code).then(function (data) {
                            if (data.length > 1) {
                                $scope.moreSuffix = true;
                            } else $scope.moreSuffix = false;
                        });
                    } else $scope.moreSuffix = false;
                } else $scope.moreSuffix = false;
            });
            //update next previous button disable
            //$scope.isAddingNew = false;
            //$scope.isEditing = false;
            $scope.$watch('isAddingNew', function (newVal) {
                if (newVal != null && newVal != undefined) {
                    if (newVal == true) {
                        $scope.disableNext = true;
                        $scope.disablePrevious = true;
                    } else {
                        $scope.disableNext = false;
                        $scope.disablePrevious = false;
                    }
                } else {
                    $scope.disableNext = false;
                    $scope.disablePrevious = false;
                }
            });
            $scope.$watch('isEditing', function (newVal) {
                if (newVal != null && newVal != undefined) {
                    if (newVal == true) {
                        $scope.disableNext = true;
                        $scope.disablePrevious = true;
                    } else {
                        $scope.disableNext = false;
                        $scope.disablePrevious = false;
                    }
                } else {
                    $scope.disableNext = false;
                    $scope.disablePrevious = false;
                }
            });

            //update employee errors
            $scope.updateEmployeeErrors = function () {
                var validNumber = new RegExp(/^[0-9]+([,.][0-9]+)?$/);
                $scope.employeeErrors = {
                    location: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Location is required.') },
                    classCode: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code is required.') },
                    moreSuffix: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code contains more than one suffix. Please select the appropriate Class Code and Suffix.') },
                    noOfEmployees: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Number of employees should be within the range of 0 to 2147483647 without decimal.') },
                    basis: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Please use only Estimated Wages for this class code within the range of 0 to 2147483647 without decimal.') },
                    perCapita: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Please use only Per Capita for this class code within the range of 0 to 2147483647 without decimal.') }
                };
                //check no of employee error
                /*if(($scope.employeeView.noOfEmployees.value != null && $scope.employeeView.noOfEmployees.value != undefined ) && (Number.isInteger($scope.employeeView.noOfEmployees.value) === false || $scope.employeeView.noOfEmployees.value < 1 || $scope.employeeView.noOfEmployees.value > 2147483647)){
                $scope.employeeErrors.noOfEmployees.status = true;
                $scope.employeeErrors.noOfEmployees.message = $filter('translate')('Number of Employees should be within the range of 1 to 2147483647 without decimal.');
                }*/
                if ($scope.employeeView.noOfEmployees.value !== '' && $scope.employeeView.noOfEmployees.value !== null && $scope.employeeView.noOfEmployees.value !== undefined) {
                    if (validNumber.test($scope.employeeView.noOfEmployees.value) === false || $scope.employeeView.noOfEmployees.value % 1 !== 0 || $scope.employeeView.noOfEmployees.value < 1 || $scope.employeeView.noOfEmployees.value > 2147483647) {
                        $scope.employeeErrors.noOfEmployees.status = true;
                        $scope.employeeErrors.noOfEmployees.message = $filter('translate')('Number of Employees should be within the range of 1 to 2147483647 without decimal.');
                    }
                }
                //checking location error
                if (!$scope.employeeView.value.location) {
                    $scope.employeeErrors.location.status = true;
                } else if (!$scope.employeeView.value.classCode) {
                    $scope.employeeErrors.classCode.status = true;
                } else if ($scope.moreSuffix) {

                    $scope.employeeErrors.moreSuffix.status = true;

                    $scope.employeeErrors.moreSuffix.message = $scope.employeeView.value.classCode.code + ' selected class contains more than one suffix. 00 suffix may not be used.';
                } else {

                    //let perCapitaClassCodes = ['0908','0913'];
                    //setting up percapita is mandatory based on selected class code
                    if ($scope.perCapitaClasses && $scope.perCapitaClasses.indexOf($scope.employeeView.value.classCode.code) != -1) {
                        if ($scope.employeeView.perCapita.value === '' || validNumber.test($scope.employeeView.perCapita.value) === false || $scope.employeeView.perCapita.value % 1 !== 0 || $scope.employeeView.perCapita.value < 0 || $scope.employeeView.perCapita.value > 2147483647) {
                            $scope.employeeErrors.perCapita.status = true;
                            $scope.employeeErrors.perCapita.message = 'Please use only Per Capita for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                        if ($scope.employeeView.value.basisAmount !== '' && $scope.employeeView.value.basisAmount !== null && $scope.employeeView.value.basisAmount !== undefined && $scope.employeeErrors.perCapita.status === false) {
                            $scope.employeeErrors.basis.status = true;
                            $scope.employeeErrors.basis.message = 'Please use only Per Capita for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                    } else {
                        if ($scope.employeeView.value.basisAmount === '' || validNumber.test($scope.employeeView.value.basisAmount) === false || $scope.employeeView.value.basisAmount % 1 !== 0 || $scope.employeeView.value.basisAmount < 0 || $scope.employeeView.value.basisAmount > 2147483647) {
                            $scope.employeeErrors.basis.status = true;
                            $scope.employeeErrors.basis.message = 'Please use only Estimated Wages for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                        if ($scope.employeeView.perCapita.value !== '' && $scope.employeeView.perCapita.value !== null && $scope.employeeView.perCapita.value !== undefined && $scope.employeeErrors.basis.status === false) {
                            console.log($scope.employeeView.perCapita.value);
                            $scope.employeeErrors.perCapita.status = true;
                            $scope.employeeErrors.perCapita.message = 'Please use only Estimated Wages for the class code ' + $scope.employeeView.value.classCode.code + ' within the range of 0 to 2147483647 without decimal.';
                        }
                    }
                }
            };
            //save in portal
            $scope.validateDec = function (key) {
                console.log('in');
                //getting key code of pressed key
                var keycode = key.which ? key.which : key.keyCode;
                //comparing pressed keycodes
                if (!(keycode == 8 || keycode == 46) && (keycode < 48 || keycode > 57)) {
                    return false;
                } else {
                    var parts = key.srcElement.value.split('.');
                    if (parts.length > 1 && keycode == 46) return false;
                    return true;
                }
            };
            $scope.onSave = function () {
                console.log('basis value');
                //$scope.employeeView.value.noOfEmployees = parseInt($scope.employeeView.value.noOfEmployees,5);
                console.log($scope.employeeView.value.basisAmount);
                console.log($scope.employeeView.value.perCapita);
                $scope.updateEmployeeErrors();
                if ($scope.checkEmployeeErrors() != true) {

                    console.log('bais in' + $scope.employeeView.value.basisAmount);
                    console.log('per capita in' + $scope.employeeView.value.perCapita);

                    if ($scope.employeeView.value.noOfEmployees !== '' && $scope.employeeView.value.noOfEmployees !== null && $scope.employeeView.value.noOfEmployees !== undefined) $scope.employeeView.noOfEmployees.value = Math.round($scope.employeeView.noOfEmployees.value);
                    if ($scope.employeeView.value.basisAmount !== undefined && $scope.employeeView.value.basisAmount !== null && $scope.employeeView.value.basisAmount !== '') {
                        console.log('we in basis');
                        $scope.employeeView.value.basisAmount = Math.round($scope.employeeView.value.basisAmount);
                        console.log($scope.employeeView.value.basisAmount);
                    }
                    if ($scope.employeeView.value.perCapita !== undefined && $scope.employeeView.value.perCapita !== null && $scope.employeeView.value.perCapita !== '') $scope.employeeView.value.perCapita = Math.round($scope.employeeView.value.perCapita);
                    if ($scope.selectedEntry > -1) {
                        //if($scope.employeeView.value.noOfEmployees != undefined || $scope.employeeView.value.noOfEmployees != null)
                        if ($scope.employeeView.value.noOfEmployees === '' || $scope.employeeView.value.noOfEmployees === null || $scope.employeeView.value.noOfEmployees === undefined) delete $scope.data.value.baseData.mSFCoveredEmployees_EXT[$scope.selectedEntry].noOfEmployees;else $scope.data.value.baseData.mSFCoveredEmployees_EXT[$scope.selectedEntry].noOfEmployees = $scope.employeeView.value.noOfEmployees;
                        console.log('before save' + $scope.employeeView.value.basisAmount);
                        if ($scope.employeeView.value.basisAmount !== undefined && $scope.employeeView.value.basisAmount !== null && $scope.employeeView.value.basisAmount !== '') {
                            console.log('on save' + $scope.employeeView.value.basisAmount);
                            $scope.data.value.baseData.mSFCoveredEmployees_EXT[$scope.selectedEntry].basisAmount = $scope.employeeView.value.basisAmount;
                        }
                        if ($scope.employeeView.value.perCapita !== undefined && $scope.employeeView.value.perCapita !== null && $scope.employeeView.value.perCapita !== '') {
                            $scope.data.value.baseData.mSFCoveredEmployees_EXT[$scope.selectedEntry].perCapita = $scope.employeeView.value.perCapita;
                        }
                    } else {
                        //update employeeView
                        if ($scope.employeeView.value.basisAmount === '' || $scope.employeeView.value.basisAmount === null || $scope.employeeView.value.basisAmount === undefined) delete $scope.employeeView.value.basisAmount;
                        if ($scope.employeeView.value.perCapita === '' || $scope.employeeView.value.perCapita === null || $scope.employeeView.value.perCapita === undefined) delete $scope.employeeView.value.perCapita;
                        if ($scope.employeeView.value.noOfEmployees === '' || $scope.employeeView.value.noOfEmployees === null || $scope.employeeView.value.noOfEmployees === undefined) delete $scope.employeeView.value.noOfEmployees;
                        $scope.data.value.baseData.mSFCoveredEmployees_EXT.push($scope.employeeView.value);
                    }
                    $scope.selectedEntry = -1;
                    $scope.isAddingNew = false;
                    $scope.isEditing = false;
                    $scope.stateErrors.missingClass = false;
                }
            };
            $scope.checkEmployeeErrors = function () {
                $scope.displayEmployeeError = false;
                angular.forEach($scope.employeeErrors, function (error) {
                    if (error.status === true) {
                        $scope.displayEmployeeError = true;
                        return;
                    }
                });
                return $scope.displayEmployeeError;
            };
            //converting for currency display
            $scope.toCurrency = function (val) {
                return { amount: val, currency: 'usd' };
            };
            /*let validNumber = new RegExp(/^\d*\.?\d*$/);
            let lastValid = document.getElementById("test1").value;*/
            $scope.validateNumber = function (elem) {

                if (validNumber.test(elem.value)) {
                    lastValid = elem.value;
                } else {
                    elem.value = lastValid;
                }
            };
            //allow numeric and decimal
            $scope.isNumberKey = function (evt) {
                var charCode = evt.which ? evt.which : evt.keyCode;
                if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57)) return false;

                return true;
            };
            $scope.onRemove = function (index, type) {
                if (type == 'exist' && $scope.data.value.baseData.mSFCoveredEmployees_EXT.length > 0) $scope.data.value.baseData.mSFCoveredEmployees_EXT.splice(index, 1);
                $scope.isAddingNew = false;
                $scope.isEditing = false;
                $scope.resetErrors();
            };
            $scope.resetErrors = function () {
                $scope.employeeErrors = {
                    location: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Location is required.') },
                    classCode: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code is required.') },
                    moreSuffix: { status: false, message: $filter('translate')('quoteandbind.wc.views.state-coverages.Class Code contains more than one suffix. Please select the appropriate Class Code and Suffix.') },
                    noOfEmployees: { status: false, message: $filter('translate')('Number of employees should be in the range between 0 to 2147483647 without decimal.') },
                    basis: { status: false, message: $filter('translate')('Please use Basis for this class code within the range of 0 to 2147483647 without decimal.') },
                    perCapita: { status: false, message: $filter('translate')('Please use  only Per Capita for this class code within the range of 0 to 2147483647 without decimal.') }
                };
            };
            $scope.onSubmit = function () {
                $scope.saveCoveredEmployees({ data: { portalcoveredEmployees: $scope.portalCoveredEmployees, existingEmployees: $scope.data.value.baseData.MSFCoveredEmployees_EXT } });
            };
        }]

    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/CoveredEmployeesDirective/CoveredEmployees.js
// module id = 1735
// module chunks = 0